exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cfd-specification{touch-action:manipulation}.cfd-specification svg{pointer-events:none}.tipok-container{visibility:hidden}.tipok-instance{display:none}.tipok-instance.is-active{display:block}.tipok-offset{position:fixed;z-index:99;padding:5px;visibility:visible}.tipok{margin-right:auto;margin-left:auto;max-height:100%;overflow:auto;box-sizing:border-box;border-radius:2px;padding:6px 16px;font-size:14px;font-family:sans-serif;line-height:20px;max-width:300px;color:#fff;background-color:rgba(97,97,97,.9)}.tipok-instance.is-active .tipok{display:block}.tipok a[href]{color:#fff}.tipok-offset-ghost{z-index:-1;top:0;left:0;visibility:hidden}.tipok-position{display:none;padding:12px}@media (min-width:720px){.tipok{padding:5px 12px;font-size:12px;line-height:16px}.tipok-position{display:none;padding:8px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08ddae84","scoped":false,"hasInlineConfig":false}!./src/assets/css/main.css
// module id = 100
// module chunks = 0